import { useRoleLayout } from "../hooks/useRoleLayout";
import SubUserMangementComponet from "../components/SubUserMangementComponet";

const SubUserManagement = () => {
  const { Layout: RoleLayout } = useRoleLayout();

  return (
    <>
      <RoleLayout>
        <SubUserMangementComponet />
      </RoleLayout>
    </>
  );
};

export default SubUserManagement;
